/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WavInputs */

const en_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const es_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const fr_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const de_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const ja_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const zh_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const ar_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const id_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const it_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const ru_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const pt_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

const ko_val_wav = /** @type {(inputs: Val_WavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV`)
};

/**
* | output |
* | --- |
* | "WAV" |
*
* @param {Val_WavInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_wav = /** @type {((inputs?: Val_WavInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WavInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_wav(inputs)
	if (locale === "es") return es_val_wav(inputs)
	if (locale === "fr") return fr_val_wav(inputs)
	if (locale === "de") return de_val_wav(inputs)
	if (locale === "ja") return ja_val_wav(inputs)
	if (locale === "zh") return zh_val_wav(inputs)
	if (locale === "ar") return ar_val_wav(inputs)
	if (locale === "id") return id_val_wav(inputs)
	if (locale === "it") return it_val_wav(inputs)
	if (locale === "ru") return ru_val_wav(inputs)
	if (locale === "pt") return pt_val_wav(inputs)
	return ko_val_wav(inputs)
});